/* mobileCasez — advanced collection filters.
   Indexes the whole collection in the browser via /collections/<handle>/products.json
   (public storefront endpoint, CDN-cached, no app and no external service).
   Facets: text, availability, sale, new-in, price range, brand (tags),
   device (product type), colour (variant options). Live counts, URL-synced,
   honest numbers only. Progressive enhancement over the server-rendered grid. */
(function () {
  'use strict';
  if (window.__mczOK === false) return;
  var col = document.querySelector('[data-mcz-collection][data-mcz-facets]');
  if (!col || col.__mczF) return;
  col.__mczF = true;

  /* ---------- config ---------- */
  var HANDLE = col.getAttribute('data-handle') || 'all';
  var TOTAL = parseInt(col.getAttribute('data-total') || '0', 10);
  var PAGE = parseInt(col.getAttribute('data-page-size') || '36', 10);
  var MONEY = col.getAttribute('data-money') || '₹{{amount}}';
  var BRANDS = (col.getAttribute('data-brands') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var MAX_PAGES = 8; // 8 × 250 = first 2000 products, disclosed in the drawer
  var NEW_DAYS = 60;

  var CURR = col.getAttribute('data-currency'), SHOP_CURR = col.getAttribute('data-shop-currency');
  if (CURR && SHOP_CURR && CURR !== SHOP_CURR) {
    // products.json prices are in the shop currency — don't client-render in a
    // different presentment currency; fall back to the server-rendered page
    col.removeAttribute('data-mcz-facets');
    var ob = col.querySelector('[data-mcz-fopen]'); if (ob) ob.style.display = 'none';
    if (window.__mczInit) window.__mczInit(document);
    return;
  }
  var grid = col.querySelector('[data-mcz-grid]');
  if (!grid) return;
  var els = {
    open: col.querySelector('[data-mcz-fopen]'),
    fcount: col.querySelector('[data-mcz-fcount]'),
    drawer: col.querySelector('[data-mcz-fdrawer]'),
    overlay: col.querySelector('[data-mcz-foverlay]'),
    close: col.querySelector('[data-mcz-fclose]'),
    status: col.querySelector('[data-mcz-fstatus]'),
    qchips: col.querySelector('[data-mcz-qchips]'),
    active: col.querySelector('[data-mcz-active]'),
    shown: col.querySelector('[data-mcz-shown]'),
    sort: col.querySelector('[data-mcz-sort]'),
    q: col.querySelector('[data-mcz-fq]'),
    devq: col.querySelector('[data-mcz-fdevq]'),
    pmin: col.querySelector('[data-mcz-pmin]'),
    pmax: col.querySelector('[data-mcz-pmax]'),
    pminR: col.querySelector('[data-mcz-pmin-r]'),
    pmaxR: col.querySelector('[data-mcz-pmax-r]'),
    fill: col.querySelector('[data-mcz-frange-fill]'),
    more: col.querySelector('[data-mcz-more]'),
    empty: col.querySelector('[data-mcz-empty]'),
    pagination: col.querySelector('[data-mcz-pagination]'),
    trunc: col.querySelector('[data-mcz-ftrunc]'),
    showBtn: col.querySelector('[data-mcz-fshow]'),
    clearAll: col.querySelector('[data-mcz-fclearall]')
  };
  var promo = grid.querySelector('[data-mcz-promo]');
  var serverHTML = grid.innerHTML;

  /* ---------- state ---------- */
  var state = { q: '', instock: false, sale: false, newin: false, pmin: null, pmax: null, brands: [], devices: [], colors: [], sort: 'featured' };
  var index = [];            // normalized products
  var priceLo = 0, priceHi = 0; // paise bounds of the whole index
  var loaded = false, loading = false, truncated = false;
  var rendered = 0, current = [], mode = 'server';
  var ratings = {};          // handle -> {r, n} harvested from server cards

  /* ---------- utils ---------- */
  function money(paise) {
    var amt = paise / 100, str;
    if (/amount_no_decimals_with_comma_separator/.test(MONEY)) str = Math.round(amt).toLocaleString('de-DE');
    else if (/amount_with_comma_separator/.test(MONEY)) str = amt.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else if (/amount_no_decimals/.test(MONEY)) str = Math.round(amt).toLocaleString('en-IN');
    else str = amt.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY.replace(/\{\{\s*amount[^}]*\}\}/, str);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  var COLORMAP = { black: '#1a1a1c', white: '#f4f4f2', blue: '#2a52be', navy: '#173b63', red: '#c0392b', green: '#2f7d4f', olive: '#6b7f0e', grey: '#8a8d90', gray: '#8a8d90', silver: '#c9ccd1', gold: '#c9a227', pink: '#e59fb1', purple: '#6f42c1', lavender: '#b7a8d3', violet: '#7a5195', orange: '#d97b29', brown: '#7a5230', beige: '#d9c7a7', cream: '#efe6d0', yellow: '#e3c341', teal: '#2a7f7f', cyan: '#4aa8c0', maroon: '#7b2d3b', transparent: '#ffffff', clear: '#ffffff' };
  function swatchHex(name) {
    var k = name.toLowerCase();
    if (COLORMAP[k]) return COLORMAP[k];
    var hit = Object.keys(COLORMAP).filter(function (c) { return k.indexOf(c) !== -1; })[0];
    return hit ? COLORMAP[hit] : null;
  }

  /* harvest real ratings the server printed (reviews-app metafields) */
  grid.querySelectorAll('[data-mcz-card][data-handle]').forEach(function (c) {
    var r = parseFloat(c.getAttribute('data-rating') || '0');
    if (r > 0) ratings[c.getAttribute('data-handle')] = { r: r, n: parseInt(c.getAttribute('data-rcount') || '0', 10) };
  });

  /* ---------- index loader ---------- */
  function normalize(p, ord) {
    /* price, strike-through and SAVE % must all come from ONE variant —
       the cheapest available one — so the card can never overstate a deal */
    var colorPos = 0;
    (p.options || []).forEach(function (o, i) {
      var n = (o.name || '').toLowerCase();
      if (n === 'color' || n === 'colour') colorPos = (o.position || i + 1);
    });
    var colors = [], avail = false, vSel = null, vAny = null;
    (p.variants || []).forEach(function (v) {
      var pr = Math.round(parseFloat(v.price) * 100);
      v.__paise = pr;
      if (v.available) { avail = true; if (!vSel || pr < vSel.__paise) vSel = v; }
      if (!vAny || pr < vAny.__paise) vAny = v;
      if (colorPos) { var cv = v['option' + colorPos]; if (cv && colors.indexOf(cv) === -1) colors.push(cv); }
    });
    var v = vSel || vAny;
    var price = v ? v.__paise : 0;
    var compare = v && v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0;
    var sale = compare > price;
    var pct = sale ? Math.round((compare - price) * 100 / compare) : 0;
    var tags = p.tags || [];
    var tl = tags.map(function (t) { return t.toLowerCase(); });
    var brands = BRANDS.filter(function (b) { return tl.indexOf(b.toLowerCase()) !== -1; });
    return {
      id: p.id, handle: p.handle, title: p.title, type: p.product_type || '',
      url: '/products/' + p.handle,
      img: (p.images && p.images[0] && p.images[0].src) || '',
      alt: (p.images && p.images[0] && p.images[0].alt) || p.title,
      tags: tl, brands: brands, colors: colors,
      price: price, compare: compare, sale: sale, pct: pct, avail: avail,
      created: Date.parse(p.created_at || 0) || 0,
      bestseller: tl.indexOf('bestseller') !== -1,
      vid: v ? v.id : 0, ord: ord
    };
  }

  function loadIndex() {
    if (loaded || loading) return;
    loading = true;
    index.length = 0; truncated = false;
    var page = 1, ord = 0;
    function next() {
      fetch('/collections/' + encodeURIComponent(HANDLE) + '/products.json?limit=250&page=' + page)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          var items = (data && data.products) || [];
          items.forEach(function (p) { index.push(normalize(p, ord++)); });
          if (els.status) els.status.textContent = index.length + ' products indexed…';
          if (items.length === 250 && page < MAX_PAGES) { page++; next(); }
          else {
            truncated = items.length === 250;
            finishIndex();
          }
        })
        .catch(function () { loading = false; if (els.status) els.status.textContent = 'Filters unavailable right now.'; });
    }
    next();
  }

  function finishIndex() {
    loaded = true; loading = false;
    priceLo = Infinity; priceHi = 0;
    index.forEach(function (p) { if (p.price < priceLo) priceLo = p.price; if (p.price > priceHi) priceHi = p.price; });
    if (priceLo === Infinity) { priceLo = 0; }
    if (els.status) els.status.textContent = index.length + ' products · live counts';
    // canonicalize URL-restored values case-insensitively against real facet values
    var canon = {};
    index.forEach(function (p) {
      p.brands.forEach(function (b) { canon[b.toLowerCase()] = b; });
      if (p.type) canon[p.type.toLowerCase()] = p.type;
      p.colors.forEach(function (c) { canon[c.toLowerCase()] = c; });
    });
    ['brands', 'devices', 'colors'].forEach(function (k) {
      state[k] = state[k].map(function (v) { return canon[v.toLowerCase()] || v; });
    });
    if (els.trunc && truncated) {
      els.trunc.hidden = false;
      els.trunc.textContent = 'Note: filtering covers the first ' + index.length + ' products of this collection.';
    }
    setupPrice();
    if (state.pmin != null || state.pmax != null) syncSliders();
    buildFacets();
    apply(true);
  }

  /* ---------- price slider ---------- */
  var RSTEPS = 100;
  function setupPrice() {
    [els.pminR, els.pmaxR].forEach(function (r) { if (r) { r.min = 0; r.max = RSTEPS; r.step = 1; } });
    if (els.pminR) els.pminR.value = 0;
    if (els.pmaxR) els.pmaxR.value = RSTEPS;
    paintRange();
  }
  function stepToPaise(s) { return Math.round(priceLo + (priceHi - priceLo) * (s / RSTEPS)); }
  function paintRange() {
    if (!els.fill || !els.pminR || !els.pmaxR) return;
    var a = parseInt(els.pminR.value, 10), b = parseInt(els.pmaxR.value, 10);
    if (a > b) { var t = a; a = b; b = t; }
    els.fill.style.left = (a / RSTEPS * 100) + '%';
    els.fill.style.right = (100 - b / RSTEPS * 100) + '%';
  }
  function rangeChanged() {
    var a = parseInt(els.pminR.value, 10), b = parseInt(els.pmaxR.value, 10);
    if (a > b) { var t = a; a = b; b = t; }
    state.pmin = a <= 0 ? null : stepToPaise(a);
    state.pmax = b >= RSTEPS ? null : stepToPaise(b);
    if (els.pmin) els.pmin.value = state.pmin == null ? '' : Math.round(state.pmin / 100);
    if (els.pmax) els.pmax.value = state.pmax == null ? '' : Math.round(state.pmax / 100);
    paintRange(); apply();
  }
  function syncSliders() {
    if (els.pminR) els.pminR.value = state.pmin == null || priceHi === priceLo ? 0 : Math.max(0, Math.min(RSTEPS, Math.round((state.pmin - priceLo) / (priceHi - priceLo) * RSTEPS)));
    if (els.pmaxR) els.pmaxR.value = state.pmax == null || priceHi === priceLo ? RSTEPS : Math.max(0, Math.min(RSTEPS, Math.round((state.pmax - priceLo) / (priceHi - priceLo) * RSTEPS)));
    paintRange();
  }
  function inputsChanged() {
    var lo = els.pmin && els.pmin.value !== '' ? Math.max(0, parseInt(els.pmin.value, 10)) * 100 : null;
    var hi = els.pmax && els.pmax.value !== '' ? Math.max(0, parseInt(els.pmax.value, 10)) * 100 : null;
    if (lo != null && hi != null && !isNaN(lo) && !isNaN(hi) && lo > hi) { var t = lo; lo = hi; hi = t; }
    state.pmin = isNaN(lo) ? null : lo; state.pmax = isNaN(hi) ? null : hi;
    syncSliders(); apply();
  }

  /* ---------- filtering ---------- */
  function matches(p, skip) {
    if (state.q) {
      var q = state.q.toLowerCase(), hay = (p.title + ' ' + p.type + ' ' + p.tags.join(' ')).toLowerCase();
      var ok = q.split(/\s+/).every(function (w) { return hay.indexOf(w) !== -1; });
      if (!ok) return false;
    }
    if (state.instock && !p.avail) return false;
    if (state.sale && !p.sale) return false;
    if (state.newin && (Date.now() - p.created) > NEW_DAYS * 864e5) return false;
    if (state.pmin != null && p.price < state.pmin) return false;
    if (state.pmax != null && p.price > state.pmax) return false;
    if (skip !== 'brand' && state.brands.length && !state.brands.some(function (b) { return p.brands.indexOf(b) !== -1; })) return false;
    if (skip !== 'device' && state.devices.length && state.devices.indexOf(p.type) === -1) return false;
    if (skip !== 'color' && state.colors.length && !state.colors.some(function (c) { return p.colors.indexOf(c) !== -1; })) return false;
    return true;
  }

  function sortItems(arr) {
    var s = state.sort;
    arr.sort(function (a, b) {
      if (s === 'price-asc') return a.price - b.price;
      if (s === 'price-desc') return b.price - a.price;
      if (s === 'newest') return b.created - a.created;
      if (s === 'discount') return b.pct - a.pct;
      return a.ord - b.ord;
    });
    return arr;
  }

  function pristine() {
    return !state.q && !state.instock && !state.sale && !state.newin && state.pmin == null && state.pmax == null &&
      !state.brands.length && !state.devices.length && !state.colors.length && state.sort === 'featured';
  }
  function activeCount() {
    return (state.q ? 1 : 0) + (state.instock ? 1 : 0) + (state.sale ? 1 : 0) + (state.newin ? 1 : 0) +
      (state.pmin != null || state.pmax != null ? 1 : 0) + state.brands.length + state.devices.length + state.colors.length;
  }

  /* ---------- card template (mirrors snippets/mcz-product-card.liquid) ---------- */
  function imgUrl(src, w) { if (!src) return ''; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
  function badge(p) {
    if (p.sale && p.pct > 0) return 'SAVE ' + p.pct + '%';
    if (p.bestseller) return 'BESTSELLER';
    if ((Date.now() - p.created) <= NEW_DAYS * 864e5) return 'NEW IN';
    return '';
  }
  function cardHTML(p) {
    var b = badge(p), rt = ratings[p.handle];
    return '<article data-mcz-card data-handle="' + esc(p.handle) + '" style="position:relative;background:#FFFFFF;border:1px solid rgba(20,21,26,.1);border-radius:22px;padding:12px;box-shadow:0 1px 2px rgba(16,17,20,.04),0 14px 30px rgba(16,17,20,.06);transition:transform .3s ease,border-color .3s ease" style-hover="transform:translateY(-6px);border-color:color-mix(in srgb, var(--accent-deep,#6B7F0E) 45%, transparent)">' +
      '<a href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '" style="position:absolute;inset:0;z-index:1;border-radius:22px"></a>' +
      '<div style="position:relative;background:#FFFFFF;border-radius:14px;aspect-ratio:1/1;display:grid;place-items:center;overflow:hidden">' +
      (p.img
        ? '<img src="' + esc(imgUrl(p.img, 600)) + '" alt="' + esc(p.alt) + '" loading="lazy" width="480" height="480" style="width:82%;height:82%;object-fit:contain;transition:transform .35s" style-hover="transform:scale(1.06)">'
        : '<div style="width:82%;height:82%;display:grid;place-items:center;color:#C9CCC6;font-family:\'Unbounded\',sans-serif">m</div>') +
      (b ? '<span style="position:absolute;top:10px;left:10px;background:#101114;color:var(--accent,#D8FF3E);font-size:10px;font-weight:700;letter-spacing:.12em;padding:6px 10px;border-radius:999px">' + b + '</span>' : '') +
      (p.vid ? '<button data-mcz-add data-variant="' + p.vid + '" data-name="' + esc(p.title) + '" aria-label="Add ' + esc(p.title) + ' to cart" style="position:absolute;right:10px;bottom:10px;z-index:2;width:44px;height:44px;border-radius:999px;border:none;background:#101114;color:var(--accent,#D8FF3E);font-size:20px;cursor:pointer;font-family:inherit;transition:transform .2s,background .2s,color .2s" style-hover="transform:scale(1.1);background:var(--accent,#D8FF3E);color:#101114">＋</button>' : '') +
      '</div>' +
      '<div style="padding:14px 6px 8px">' +
      '<h3 style="font-size:15.5px;font-weight:600;margin:0;line-height:1.35">' + esc(p.title) + '</h3>' +
      (p.type ? '<div style="color:#5C615B;font-size:12.5px;margin-top:3px">' + esc(p.type) + '</div>' : '') +
      '<div style="display:flex;align-items:baseline;gap:9px;margin-top:11px;flex-wrap:wrap">' +
      '<span style="font-family:\'Unbounded\',sans-serif;font-weight:700;font-size:16.5px">' + money(p.price) + '</span>' +
      (p.sale && p.compare > p.price ? '<s style="color:#5C615B;font-size:12.5px">' + money(p.compare) + '</s><span style="color:var(--accent-deep,#6B7F0E);font-size:11px;font-weight:700;letter-spacing:.06em">SAVE ' + p.pct + '%</span>' : '') +
      '</div>' +
      (rt && rt.n > 0 ? '<div style="margin-top:8px;font-size:12px"><span style="color:var(--accent-deep,#6B7F0E)">★</span> <span style="color:#5C615B">' + (Math.round(rt.r * 10) / 10) + ' / 5 · ' + rt.n + ' review' + (rt.n === 1 ? '' : 's') + '</span></div>' : '') +
      '</div></article>';
  }

  /* ---------- rendering ---------- */
  function render(reset) {
    if (reset) rendered = 0;
    var batch = current.slice(rendered, rendered + PAGE);
    var html = batch.map(cardHTML).join('');
    if (rendered === 0) {
      grid.innerHTML = html;
      if (promo && current.length) grid.appendChild(promo);
    } else if (promo && promo.parentNode === grid) {
      promo.insertAdjacentHTML('beforebegin', html);
    } else {
      grid.insertAdjacentHTML('beforeend', html);
    }
    rendered += batch.length;
    if (els.more) {
      var left = current.length - rendered;
      els.more.style.display = left > 0 ? 'flex' : 'none';
      var btn = els.more.querySelector('button');
      if (btn && left > 0) btn.textContent = 'Show more (' + left + ' left)';
    }
    mode = 'client';
    if (window.__mczInit) window.__mczInit(grid);
  }

  function restoreServer() {
    if (mode === 'server') return;
    grid.innerHTML = serverHTML;
    promo = grid.querySelector('[data-mcz-promo]');
    grid.style.display = 'grid';
    if (els.pagination) els.pagination.style.display = '';
    if (els.more) els.more.style.display = 'none';
    if (els.empty) els.empty.style.display = 'none';
    if (els.shown) els.shown.textContent = TOTAL + (TOTAL === 1 ? ' case' : ' cases');
    mode = 'server';
    if (window.__mczInit) window.__mczInit(grid);
  }

  function apply(initial) {
    if (!loaded) { loadIndex(); return; }
    syncURL();
    paintActive();
    buildFacets();
    if (pristine()) { restoreServer(); return; }
    current = sortItems(index.filter(function (p) { return matches(p); }));
    if (els.pagination) els.pagination.style.display = 'none';
    if (current.length === 0) {
      grid.style.display = 'none';
      if (els.empty) els.empty.style.display = '';
      if (els.more) els.more.style.display = 'none';
      mode = 'client';
    } else {
      grid.style.display = 'grid';
      if (els.empty) els.empty.style.display = 'none';
      render(true);
    }
    if (els.shown) els.shown.textContent = current.length + (current.length === 1 ? ' case' : ' cases') + (truncated ? ' · first ' + index.length + ' indexed' : '');
    if (els.showBtn) els.showBtn.textContent = current.length === 0 ? 'Nothing matches' : 'Show ' + current.length + ' result' + (current.length === 1 ? '' : 's');
  }

  /* ---------- facet UI ---------- */
  function counts(key, getter) {
    var m = {};
    index.forEach(function (p) {
      if (!matches(p, key)) return;
      getter(p).forEach(function (v) { if (v) m[v] = (m[v] || 0) + 1; });
    });
    return m;
  }
  function checkRow(group, val, label, count, on) {
    return '<label class="mcz-fcheck"><input type="checkbox" data-mcz-fval="' + esc(group) + '|' + esc(val) + '"' + (on ? ' checked' : '') + '><span></span>' +
      '<em style="font-style:normal">' + esc(label) + '</em><i class="mcz-fcount" style="font-style:normal">' + count + '</i></label>';
  }
  function buildFacets() {
    if (!loaded) return;
    var bC = counts('brand', function (p) { return p.brands; });
    var dC = counts('device', function (p) { return p.type ? [p.type] : []; });
    var cC = counts('color', function (p) { return p.colors; });

    var bWrap = col.querySelector('[data-mcz-fgroup="brand"]');
    if (bWrap) {
      var bKeys = Object.keys(bC).sort(function (a, b) { return bC[b] - bC[a]; });
      bWrap.innerHTML = bKeys.map(function (k) { return checkRow('brand', k, k, bC[k], state.brands.indexOf(k) !== -1); }).join('') || '<div style="color:#5C615B;font-size:12.5px">No brand tags found.</div>';
    }
    var dWrap = col.querySelector('[data-mcz-fgroup="device"]');
    if (dWrap) {
      var dq = (els.devq && els.devq.value || '').toLowerCase();
      var dKeys = Object.keys(dC).sort();
      if (dq) dKeys = dKeys.filter(function (k) { return k.toLowerCase().indexOf(dq) !== -1; });
      dWrap.innerHTML = dKeys.map(function (k) { return checkRow('device', k, k, dC[k], state.devices.indexOf(k) !== -1); }).join('') || '<div style="color:#5C615B;font-size:12.5px">No matching models.</div>';
    }
    var cWrap = col.querySelector('[data-mcz-fgroup="color"]');
    if (cWrap) {
      var cKeys = Object.keys(cC).sort(function (a, b) { return cC[b] - cC[a]; });
      cWrap.innerHTML = cKeys.map(function (k) {
        var hex = swatchHex(k), on = state.colors.indexOf(k) !== -1;
        return '<button type="button" class="mcz-fswatch" data-on="' + on + '" data-mcz-fval="color|' + esc(k) + '">' +
          (hex ? '<i style="background:' + hex + '"></i>' : '<i style="background:#fff;display:inline-flex;align-items:center;justify-content:center;font-size:9px;color:#5C615B">' + esc(k.charAt(0).toUpperCase()) + '</i>') +
          esc(k) + ' <span class="mcz-fcount">' + cC[k] + '</span></button>';
      }).join('') || '<div style="color:#5C615B;font-size:12.5px">No colour options found.</div>';
      var cwr = col.querySelector('[data-mcz-fgroup-wrap="color"]');
      if (cwr) cwr.style.display = cKeys.length || state.colors.length ? '' : 'none';
    }
    buildQuickChips(bC);
  }

  function buildQuickChips(bC) {
    if (!els.qchips) return;
    var keys = BRANDS.filter(function (b) { return bC[b]; });
    els.qchips.innerHTML = keys.slice(0, 6).map(function (k) {
      var on = state.brands.indexOf(k) !== -1;
      return '<button type="button" class="mcz-qchip" data-on="' + on + '" data-mcz-fval="brand|' + esc(k) + '">' + esc(k) + ' <span class="mcz-fcount">' + bC[k] + '</span></button>';
    }).join('');
  }

  function paintActive() {
    if (!els.active) return;
    var chips = [];
    function chip(label, group, val) { chips.push('<button type="button" class="mcz-fchip" data-mcz-frm="' + esc(group) + '|' + esc(val == null ? '' : val) + '">' + esc(label) + ' ✕</button>'); }
    if (state.q) chip('“' + state.q + '”', 'q');
    if (state.instock) chip('In stock', 'instock');
    if (state.sale) chip('On sale', 'sale');
    if (state.newin) chip('New in', 'newin');
    if (state.pmin != null || state.pmax != null) chip((state.pmin != null ? money(state.pmin) : money(priceLo)) + ' – ' + (state.pmax != null ? money(state.pmax) : money(priceHi)), 'price');
    state.brands.forEach(function (b) { chip(b, 'brand', b); });
    state.devices.forEach(function (d) { chip(d, 'device', d); });
    state.colors.forEach(function (c) { chip(c, 'color', c); });
    els.active.innerHTML = chips.join('');
    els.active.style.display = chips.length ? 'flex' : 'none';
    var clr = col.querySelectorAll('[data-mcz-clear]');
    clr.forEach(function (b) { b.style.display = chips.length ? '' : 'none'; });
    if (els.fcount) {
      var n = activeCount();
      els.fcount.style.display = n ? 'inline-flex' : 'none';
      els.fcount.textContent = n;
    }
  }

  /* ---------- URL sync ---------- */
  function syncURL() {
    try {
      var u = new URL(window.location.href);
      var map = { q: state.q || null, instock: state.instock ? '1' : null, sale: state.sale ? '1' : null, fresh: state.newin ? '1' : null, pmin: state.pmin != null ? Math.round(state.pmin / 100) : null, pmax: state.pmax != null ? Math.round(state.pmax / 100) : null, brand: state.brands.join('~') || null, device: state.devices.join('~') || null, color: state.colors.join('~') || null, sort: state.sort !== 'featured' ? state.sort : null };
      Object.keys(map).forEach(function (k) { map[k] == null ? u.searchParams.delete(k) : u.searchParams.set(k, map[k]); });
      history.replaceState(null, '', u.toString());
    } catch (e) { }
  }
  function readURL() {
    try {
      var u = new URL(window.location.href), any = false, g = function (k) { return u.searchParams.get(k); };
      if (g('q')) { state.q = g('q'); any = true; }
      if (g('instock')) { state.instock = true; any = true; }
      if (g('sale')) { state.sale = true; any = true; }
      if (g('fresh')) { state.newin = true; any = true; }
      if (g('pmin')) { state.pmin = parseInt(g('pmin'), 10) * 100; any = true; }
      if (g('pmax')) { state.pmax = parseInt(g('pmax'), 10) * 100; any = true; }
      if (g('brand')) { state.brands = g('brand').split('~').filter(Boolean); any = true; }
      if (g('b')) { state.brands = [g('b')]; any = true; } // legacy chip links
      if (g('device')) { state.devices = g('device').split('~').filter(Boolean); any = true; }
      if (g('color')) { state.colors = g('color').split('~').filter(Boolean); any = true; }
      if (g('sort')) { state.sort = g('sort'); if (els.sort) els.sort.value = state.sort; any = true; }
      if (g('q') && els.q) els.q.value = state.q;
      if (g('instock') && col.querySelector('[data-mcz-ftoggle="instock"]')) col.querySelector('[data-mcz-ftoggle="instock"]').checked = true;
      if (g('sale') && col.querySelector('[data-mcz-ftoggle="sale"]')) col.querySelector('[data-mcz-ftoggle="sale"]').checked = true;
      if (g('fresh') && col.querySelector('[data-mcz-ftoggle="newin"]')) col.querySelector('[data-mcz-ftoggle="newin"]').checked = true;
      if (g('pmin') && els.pmin) els.pmin.value = g('pmin');
      if (g('pmax') && els.pmax) els.pmax.value = g('pmax');
      return any;
    } catch (e) { return false; }
  }

  /* ---------- drawer ---------- */
  var lastFocus = null;
  function openDrawer() {
    loadIndex();
    lastFocus = document.activeElement;
    els.drawer.hidden = false; els.overlay.hidden = false;
    requestAnimationFrame(function () { els.drawer.classList.add('on'); els.overlay.classList.add('on'); });
    if (els.open) els.open.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { els.close && els.close.focus(); }, 60);
  }
  function closeDrawer() {
    els.drawer.classList.remove('on'); els.overlay.classList.remove('on');
    if (els.open) els.open.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setTimeout(function () { els.drawer.hidden = true; els.overlay.hidden = true; }, 330);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- events ---------- */
  if (els.open) els.open.addEventListener('click', openDrawer);
  if (els.close) els.close.addEventListener('click', closeDrawer);
  if (els.overlay) els.overlay.addEventListener('click', closeDrawer);
  if (els.showBtn) els.showBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (!els.drawer || els.drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab') {
      var f = els.drawer.querySelectorAll('button, input, select, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  col.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-mcz-ftoggle')) {
      state[t.getAttribute('data-mcz-ftoggle')] = t.checked; apply(); return;
    }
    if (t.hasAttribute && t.hasAttribute('data-mcz-fval') && t.type === 'checkbox') {
      var kv = t.getAttribute('data-mcz-fval').split('|'), arrName = kv[0] === 'brand' ? 'brands' : kv[0] === 'device' ? 'devices' : 'colors';
      var arr = state[arrName], i = arr.indexOf(kv[1]);
      if (t.checked && i === -1) arr.push(kv[1]);
      if (!t.checked && i !== -1) arr.splice(i, 1);
      apply(); return;
    }
  });
  col.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('button[data-mcz-fval]');
    if (sw) {
      var kv = sw.getAttribute('data-mcz-fval').split('|'), arrName = kv[0] === 'brand' ? 'brands' : kv[0] === 'device' ? 'devices' : 'colors';
      loadIndex();
      var arr = state[arrName], i = arr.indexOf(kv[1]);
      i === -1 ? arr.push(kv[1]) : arr.splice(i, 1);
      apply(); return;
    }
    var rm = e.target.closest && e.target.closest('[data-mcz-frm]');
    if (rm) {
      var kv2 = rm.getAttribute('data-mcz-frm').split('|');
      if (kv2[0] === 'q') { state.q = ''; if (els.q) els.q.value = ''; }
      else if (kv2[0] === 'price') { state.pmin = state.pmax = null; if (els.pmin) els.pmin.value = ''; if (els.pmax) els.pmax.value = ''; setupPrice(); }
      else if (kv2[0] === 'instock' || kv2[0] === 'sale' || kv2[0] === 'newin') { state[kv2[0]] = false; var cb = col.querySelector('[data-mcz-ftoggle="' + kv2[0] + '"]'); if (cb) cb.checked = false; }
      else { var an = kv2[0] === 'brand' ? 'brands' : kv2[0] === 'device' ? 'devices' : 'colors'; var ix = state[an].indexOf(kv2[1]); if (ix !== -1) state[an].splice(ix, 1); }
      apply(); return;
    }
    var mr = e.target.closest && e.target.closest('[data-mcz-more] button');
    if (mr) { render(false); return; }
    var cl = e.target.closest && e.target.closest('[data-mcz-clear]');
    if (cl) { clearAll(); return; }
  });
  if (els.clearAll) els.clearAll.addEventListener('click', clearAll);
  function clearAll() {
    state = { q: '', instock: false, sale: false, newin: false, pmin: null, pmax: null, brands: [], devices: [], colors: [], sort: state.sort };
    if (els.q) els.q.value = '';
    if (els.pmin) els.pmin.value = ''; if (els.pmax) els.pmax.value = '';
    col.querySelectorAll('[data-mcz-ftoggle]').forEach(function (c) { c.checked = false; });
    setupPrice();
    apply();
  }
  if (els.q) els.q.addEventListener('input', debounce(function () { state.q = els.q.value.trim(); loadIndex(); apply(); }, 220));
  if (els.devq) els.devq.addEventListener('input', debounce(function () { buildFacets(); }, 150));
  if (els.pmin) els.pmin.addEventListener('input', debounce(inputsChanged, 350));
  if (els.pmax) els.pmax.addEventListener('input', debounce(inputsChanged, 350));
  if (els.pminR) { els.pminR.addEventListener('input', paintRange); els.pminR.addEventListener('change', rangeChanged); }
  if (els.pmaxR) { els.pmaxR.addEventListener('input', paintRange); els.pmaxR.addEventListener('change', rangeChanged); }
  if (els.sort) els.sort.addEventListener('change', function () {
    state.sort = els.sort.value;
    if (state.sort === 'featured' && pristine()) { syncURL(); restoreServer(); return; }
    loadIndex(); apply();
  });

  /* ---------- boot ---------- */
  // quick chips appear instantly (no counts); the index loads only when the
  // shopper actually engages — no multi-page prefetch on every collection view
  if (els.qchips) {
    els.qchips.innerHTML = BRANDS.slice(0, 6).map(function (k) {
      return '<button type="button" class="mcz-qchip" data-on="false" data-mcz-fval="brand|' + esc(k) + '">' + esc(k) + '</button>';
    }).join('');
  }
  var fromURL = readURL();
  if (fromURL) loadIndex();
  var AD_LANDING = /[?&](gclid|gbraid|wbraid|msclkid|fbclid|ttclid)=/i.test(window.location.search);
  try { if (!AD_LANDING && new URL(window.location.href).searchParams.get('filters') === 'open') openDrawer(); } catch (e) { }
})();
